import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { EventNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FilterDetailList, FiltersLeadIn, hasFilters, Times, Within } from '../condition-parts';

type EventConditionProps = { node: EventNode };

/**
 * The event and what the person did with it. An event the person is waited on to perform, or
 * performs to exit, reads forward, "perform the event purchase", as Ember's
 * `cio-condition-viewer-event` words a foreign event under `@allowForeignEvent`; the rest read as
 * already done, "purchase performed".
 */
function EventSentence({ node }: EventConditionProps) {
  if (node.isPerformedWhileWaiting === true || node.isPerformedToExit === true) {
    return (
      <>
        perform the event <ConditionViewerTerm>{node.name}</ConditionViewerTerm>
      </>
    );
  }
  return (
    <>
      <ConditionViewerTerm>{node.name}</ConditionViewerTerm> {node.inverse ? 'not performed' : 'performed'}
    </>
  );
}

export function EventCondition({ node }: EventConditionProps) {
  return (
    <ConditionViewerItem
      icon={getIconForNode(node)}
      details={hasFilters(node.filters) ? <FilterDetailList filters={node.filters} /> : undefined}
    >
      <EventSentence node={node} />
      <Times times={node.times} />
      <Within within={node.within} />
      <FiltersLeadIn filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionViewerItem>
  );
}
